import Vue from "vue";
import loginMixin from "@/mixins/loginMixin";
export default Vue.extend({
    mixins: [loginMixin],
    props: {
        templateConfig: {}
    }
});
